import React, { useEffect, useState } from "react";
import axios from "axios";
import Table from "../shared/table/Table";
import { FiEye, FiEdit3, FiTrash2 } from "react-icons/fi";
import { Link } from "react-router-dom";
import "./LanguageTable.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faListUl } from "@fortawesome/free-solid-svg-icons";
import useTranslations from "../../hooks/useTranslations";
import useUserLanguage from "../../hooks/useUserLanguage";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";



const LanguageTable = () => {
  const [languages, setLanguages] = useState([]);
  const [loading, setLoading] = useState(false);

   // Kullanıcının dilini al ve çevirileri getir
   const language = useUserLanguage();
   const { translations } = useTranslations(language);
   const getText = (key, defaultValue) => translations[key] || defaultValue;

  useEffect(() => {
    fetchLanguages();
  }, []);

  const fetchLanguages = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("admin_token");
      const resp = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/languages/list`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setLanguages(resp.data);
    } catch (error) {
      console.error("❌ Diller çekilemedi:", error);
      setLanguages([]);
    }
    setLoading(false);
  };

  const handleDelete = (id) => {
    confirmAlert({
      title: getText("DELETE_CONFIRM_TITLE", "Kalıcı Sil"),
      message: getText("DELETE_CONFIRM_MSG", "Bu dili kalıcı olarak silmek istediğinize emin misiniz?"),
      buttons: [
        {
          label: getText("YES_DELETE", "Evet, Sil"),
          onClick: async () => {
            try {
              const token = localStorage.getItem("admin_token");
              await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/api/languages/${id}`, {
                headers: { Authorization: `Bearer ${token}` },
              });
              toast.success(getText("SUCCESS_DESTROYED", "Öğe kalıcı olarak silindi!"));
              setLanguages((prev) => prev.filter((item) => item.id !== id)); // tablodan kaldır
            } catch (error) {
              console.error("Kalıcı silme hatası:", error);
              toast.error(getText("ERROR_DESTROY_FAILED", "Kalıcı silme başarısız!"));
            }
          },
        },
        {
          label: getText("CANCEL", "İptal"),
          onClick: () => toast.info(getText("DELETE_CANCELLED", "İşlem iptal edildi")),
        },
      ],
    });
  };

  const DefaultStatusCell = ({ row }) => {
    const rowIndex = row.index;
    const langId = row.original.id;
    const initialStatus = row.original.default_status === 1;
    const [isDefault, setIsDefault] = useState(initialStatus);

    const toggleDefaultLanguage = async () => {
        setLanguages((prev) =>
            prev.map((lang, index) => ({
                ...lang,
                default_status: index === rowIndex ? 1 : 0, // Seçili dili 1 yap, diğerlerini sıfırla
            }))
        );

        setIsDefault(true); // Seçili dil true olacak

        try {
            await axios.put(
                `${process.env.REACT_APP_API_BASE_URL}/api/languages/default/${langId}`,
                {},
                { headers: { Authorization: `Bearer ${localStorage.getItem("admin_token")}` } }
            );
        } catch (error) {
            console.error("❌ Varsayılan dil güncellenemedi:", error);
            fetchLanguages(); // Hata olursa tekrar çek
        }
    };

    return (
        <div className="form-check form-switch text-end d-flex align-items-end justify-content-end">
            <input
                className="form-check-input custom-checkbox"
                type="checkbox"
                role="switch"
                checked={isDefault}
                onChange={toggleDefaultLanguage}
                style={{ cursor: "pointer", width: "45px", height: "22px", transition: "0.3s ease-in-out"}}
            />
        </div>
    );
};

  const StatusSwitchCell = ({ row }) => {
    const rowIndex = row.index; // tablo sırasını bul
    const langId = row.original.id;
    const initialStatus = row.original.status; // true veya false
    const [isChecked, setIsChecked] = useState(initialStatus);
    


    // Toggle fonksiyonu
    const toggleStatus = async () => {
      const newStatus = !isChecked;   // basitçe tersine çevir
  setIsChecked(newStatus);   
      try {
        await axios.put(
          `${process.env.REACT_APP_API_BASE_URL}/api/languages/status/${langId}`,
          { status: newStatus },
          { headers: { Authorization: `Bearer ${localStorage.getItem("admin_token")}` } }
        );
         // Local state'te tablo satırı güncelleme
    setLanguages(prev => {
      const updated = [...prev];
      updated[rowIndex].status = newStatus; // boolean
      return updated;
    });
      } catch (error) {
        console.error("❌ Dil durumu güncellenemedi:", error);
        setIsChecked(isChecked); // revert
      }
    };


    return (
      <div className="form-check form-switch text-end d-flex align-items-end justify-content-end">
        <input
          className="form-check-input custom-checkbox"
          type="checkbox"
          role="switch"
          checked={isChecked}
          onChange={toggleStatus}
          style={{ cursor: "pointer", width: "45px", height: "22px", transition: "0.3s ease-in-out" }}
        />
        <span
          className={`badge ms-2 ${isChecked ? "badge-success" : "badge-danger"}`}
          style={{
            padding: "6px 12px",
            borderRadius: "8px",
            fontSize: "14px",
            fontWeight: "bold",
            transition: "0.3s ease-in-out",
          }}
        />
      </div>
    );
  };


  const columns = [
    { accessorKey: "id",  header: () => getText("TABLE_ID_LABEL"),
      meta: { headerClassName: 'text-start', className: 'text-start' },
     },
     {
      accessorKey: "flag",
      header: () => getText("TABLE_FLAG_LABEL"),
      meta: { headerClassName: "text-start", className: "text-start flag-column" },
      cell: (info) => {
        const flagUrl = info.row.original.flag;
        console.log("flag URL:", flagUrl); // Doğru formatta mı?

        return (
          <div className="text-start">
            {flagUrl ? (
              <img
                src={`http://localhost:4000${flagUrl}`}
                alt="Flag"
                className="flag-img"
                style={{ width: "40px", height: "25px", borderRadius: "5px", border: "1px solid #ddd" }}
              />
            ) : (
              <span style={{ color: "#999", fontSize: "12px" }}> </span>
            )}
          </div>
        );
      },
    },
    { accessorKey: "code", header: () => getText("TABLE_CODE_LABEL"),
      meta: { headerClassName: 'text-start', className: 'text-start code-column' },
    },
    { accessorKey: "name",  header: () => getText("TABLE_LANGUAGE_NAME_LABEL"),
      meta: { headerClassName: 'text-start', className: 'text-start name-column' },
     },

    

     {
      accessorKey: "default_status",
      header: () => <div style={{ textAlign: "end", width: "100%" }}>{getText("TABLE_DEFAULT_LANGUAGE_LABEL")}</div>,
      meta: { headerClassName: "text-end", className: "text-end" },
      cell: (info) => <DefaultStatusCell row={info.row} />,
  },
    {
      accessorKey: "status",
       header: () => <div style={{ textAlign: "end", width: "100%" }}>{getText("TABLE_STATUS_LABEL")}</div>,
      meta: { headerClassName: 'text-end', className: 'text-end' },

      cell: (info) => <StatusSwitchCell row={info.row} />,
   
    },

   

    {
      accessorKey: "actions",
      header: () => <div style={{ textAlign: "right", paddingRight: "50px" }}>{getText("TABLE_ACTIONS_LABEL")}</div>,
      meta: { headerClassName: 'text-end', className: 'text-end' },
      enableSorting: false,
      cell: (info) => {
        const langId = info.row.original.id;
        return (
          <div className="hstack gap-2 justify-content-end" style={{ paddingRight: "0px" }}>
            <Link
              to={`/admin/language/view/${langId}`}
              className="avatar-text avatar-md text-primary bg-soft-primary border-soft-primary"
              title={getText("VIEW")} 
            >
              <FiEye />
            </Link>
            <Link
              to={`/admin/language/edit/${langId}`}
              className="avatar-text avatar-md text-success bg-soft-success border-soft-success"
              title={getText("EDIT")}
            >
              <FiEdit3 />
            </Link>
            <Link
              to={`/admin/language/translation/${langId}`}
              className="avatar-text avatar-md text-warning bg-soft-warning border-soft-warning"
              title={getText("TRANSLATION")}
            >
              <FontAwesomeIcon icon={faListUl} />
            </Link>
            <button
              type="button"
              onClick={() => handleDelete(langId)}
              className="avatar-text avatar-md text-danger bg-soft-danger border-soft-danger"
              title={getText("DELETE")}
            >
              <FiTrash2 />
            </button>

          </div>
        );
      },
    },
  ];

  if (loading) return <p>⏳{getText("LOADING_MSG")}</p>;
  return <Table data={languages} columns={columns} />;
};

export default LanguageTable;
